import { render } from "./PantryRecommendMainView.vue?vue&type=template&id=16896268&ts=true"
import script from "./PantryRecommendMainView.vue?vue&type=script&lang=ts"
export * from "./PantryRecommendMainView.vue?vue&type=script&lang=ts"

import "./PantryRecommendMainView.vue?vue&type=style&index=0&id=16896268&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__